export default "__VITE_ASSET__C5kD8tZD__"